import {
  UPDATE_SUGG_ARTICLES,
  UPDATE_SUGG_ARTICLE_TYPE,
  UPDATE_RECOMMENDED_LINKS_ADP_DATA,
  RESET_ANALYTICS_STATES,
} from './types';

//ADP events payload
export const updateSuggestedArticles = (data) => {
  return {
    type: UPDATE_SUGG_ARTICLES,
    payload: data,
  };
};

export const updateSuggestedArticleType = (data) => {
  return {
    type: UPDATE_SUGG_ARTICLE_TYPE,
    payload: data,
  };
};

export const updateRecommendedLinksAdpData = (data) => {
  return {
    type: UPDATE_RECOMMENDED_LINKS_ADP_DATA,
    payload: data,
  };
};
export const resetAnalyticsStates = (data) => {
  return {
    type: RESET_ANALYTICS_STATES,
    payload: data,
  };
};
